import ImportRateCardMenuButton, { ImportRateScope } from '../Utils/ImportRateCardMenuButton';

export default function EquipmentImportRateCardMenuButton({
  onSelect,
}: {
  onSelect: (scope: ImportRateScope) => void;
}) {
  return <ImportRateCardMenuButton onSelect={onSelect} idPrefix="import-equipment-rate-card" />;
}
